import addStylesheet from './addStylesheet.js';
export default function (sources, callback = null, options = null) {
  if (!Array.isArray(sources)) {
    addStylesheet(sources, callback, options);
    return;
  }

  // Ensure ID is never passed through.
  if (options) {
    delete options.id;
  }
  let doneCount = 0;
  for (let i = 0; i < sources.length; i++) {
    addStylesheet(sources[i], () => {
      doneCount++;
      if (doneCount === sources.length && callback) {
        callback();
      }
    }, options);
  }
}